import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BasketPageService_PriceRiseHintLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {useBasketToken, useBasketTokenAwaitedFullSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../../../../features/ReductionsState/useReductionsStateRequestParameter';

export const usePriceRiceAlert = ({
  itemKey,
  disabled,
}: {
  itemKey: string;
  disabled: boolean;
}) => {
  const {token: basketToken} = useBasketToken();
  const {session, refetchesDisabled} = useBasketTokenAwaitedFullSession();

  return useGrpcRequest(
    BasketPageService_PriceRiseHintLazy,
    {
      session: session!,
      itemKey,
      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
    },
    {disabled: disabled || refetchesDisabled},
  );
};
